"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeTexts = void 0;
const web_ui_features_1 = require("@gruposantander/web-ui-features");
/**
 * Merge default translations with overridden translations and return the result.
 * If no overridden translations are passed, return default translations.
 * @param translations - default translations
 * @param overriddenTranslations - optional overridden translations
 * @returns merged translations
 */
const mergeTexts = (translations, overriddenTranslations) => {
    const translationsMerged = overriddenTranslations ? (0, web_ui_features_1.mergeDeep)(translations, overriddenTranslations) : translations;
    return translationsMerged;
};
exports.mergeTexts = mergeTexts;
//# sourceMappingURL=mergeTexts.js.map